import React, { useEffect, useState } from "react";
import FroalaEditor from "react-froala-wysiwyg";
import { useDispatch } from "react-redux";
import { launchesActions } from "../../../store/launches/launchesActions";
import EmptyTextarea from "../Textarea";

// new FroalaEditor(".selector", {
//   toolbarButtons: {
//     moreText: {
//       buttons: [
//         "bold",
//         "italic",
//         "underline",
//         "strikeThrough",
//         "subscript",
//         "superscript",
//         "fontFamily",
//         "fontSize",
//         "textColor",
//         "backgroundColor",
//         "inlineClass",
//         "inlineStyle",
//         "clearFormatting",
//       ],
//     },
//     moreParagraph: {
//       buttons: [
//         "alignLeft",
//         "alignCenter",
//         "formatOLSimple",
//         "alignRight",
//         "alignJustify",
//         "formatOL",
//         "formatUL",
//         "paragraphFormat",
//         "paragraphStyle",
//         "lineHeight",
//         "outdent",
//         "indent",
//         "quote",
//       ],
//     },
//     moreRich: {
//       buttons: [
//         "insertLink",
//         "insertImage",
//         "insertVideo",
//         "insertTable",
//         "emoticons",
//         "fontAwesome",
//         "specialCharacters",
//         "embedly",
//         "insertFile",
//         "insertHR",
//       ],
//     },
//     moreMisc: {
//       buttons: [
//         "undo",
//         "redo",
//         "fullscreen",
//         "print",
//         "getPDF",
//         "spellChecker",
//         "selectAll",
//         "html",
//         "help",
//       ],
//       align: "right",
//       buttonsVisible: 2,
//     },
//   },
// });

const defaultToolbarButtons = {
  moreRich: {
    buttons: [
      "insertLink",
      "insertImage",
      "insertTable",
      "emoticons",
      "fontAwesome",
      "specialCharacters",
      "embedly",
      "insertHR",
    ],
  },
  moreText: {
    buttons: [
      "bold",
      "italic",
      "underline",
      "strikeThrough",
      "subscript",
      "superscript",
      "fontFamily",
      "fontSize",
      "textColor",
      "backgroundColor",
      "inlineClass",
      "inlineStyle",
      "clearFormatting",
    ],
  },

  moreParagraph: {
    buttons: [
      "alignLeft",
      "alignCenter",
      "formatOLSimple",
      "alignRight",
      "alignJustify",
      "formatOL",
      "formatUL",
      "paragraphFormat",
      "paragraphStyle",
      "lineHeight",
      "outdent",
      "indent",
      "quote",
    ],
  },

  moreMisc: {
    buttons: [
      "undo",
      "redo",
      "print",
      "getPDF",
      "spellChecker",
      "selectAll",
      "html",
      "help",
    ],
    align: "right",
    buttonsVisible: 2,
  },
};

var testUrl = "";

const FrolaEditor = ({
  model,
  onHandleModelChange,
  charCounterMax = 100000,
  conversationPlateform,
  maxWidth = "700px",
  comDescription,
  placeholder = `Type Something`,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `[data-cmd="insertImage"] { display: inline-block !important; }`;
    document.head.appendChild(style);
  }, []);
  const uploadFroalaImage = file => {
    dispatch(launchesActions.uploadImage(file)).then(res => {
      if (res.success) {
        testUrl = res.data.url;
      }
    });
  };

  return (
    <div className='fr-view' style={{ maxWidth: maxWidth, overflow: "auto" }}>
      {conversationPlateform === "Facebook" ||
      conversationPlateform === "Instagram" ? (
        <EmptyTextarea
          placeholder={placeholder}
          value={comDescription}
          onChange={onHandleModelChange}
        />
      ) : (
        <FroalaEditor
          model={model}
          onModelChange={onHandleModelChange}
          tag='textarea'
          config={{
            toolbarButtons: defaultToolbarButtons,
            placeholderText: placeholder,
            events: {
              "image.inserted": function ($img, response) {
                $img[0].src =
                  "https://logosbynick.com/wp-content/uploads/2021/01/animated-gif.gif";
                setTimeout(() => {
                  $img[0].src = testUrl;
                }, 7000);
              },
              "image.beforeUpload": function (images) {
                uploadFroalaImage(images);
              },
            },
            charCounterMax: charCounterMax,
            enter: FroalaEditor.ENTER_BR,
            key: "VCC6kE4A3D3H3C7C7C6cWHNGGDTCWHIg1Ee1Oc2Yc1b1Lg1POkB6B5F5A3F3E3B3F2A5C3==",
          }}
        />
      )}
    </div>
  );
};

export { FrolaEditor };
